import { h, Component } from 'preact';
import  './index.styl';
import upSvg from '!svg-inline-loader!./up.svg';
import minusSVG from '!svg-inline-loader!./minus.svg';
import envelopeSvg from '!svg-inline-loader!./envelope.svg';
import iconSvg from '!svg-inline-loader!./minus.svg';
import agentSvg from '!svg-inline-loader!./agent.svg';
import {getCss,guid} from './Api';
import Bubble from './Bubble';
import {TransitionMotion, spring} from 'preact-motion';
import Detect from './DetectOS';


const transitionTime = 600;

export default class App extends Component {
	constructor(props) {
		super(props);
		this.state = {opened: props.opened,hidden: !props.opened,progress:false,styleCss:''};
		//console.log('app const',this.state,upSvg);
		// import("https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css").then((r)=>{
		// 	console.log('t.css loaded',r);
		// })
		// .catch((e)=>{
		// 	console.log('e t css',e.stack);
		// })
		this.guid = guid();
		this.loadCss = this.loadCss.bind(this);
		this.closeChat = this.closeChat.bind(this);
		this.openChat = this.openChat.bind(this);
		this.postMes = this.postMes.bind(this);
		this.messageHandler = this.messageHandler.bind(this);
		this.toggleChat = this.toggleChat.bind(this);
		this.hideChat = this.hideChat.bind(this);		
		this.deauthenticate = this.deauthenticate.bind(this);
		this.authenticateFunc = this.authenticateFunc.bind(this);
		this.loadCss();
		
	}

	componentDidMount() {
		window.addEventListener('message',this.messageHandler,false);

		// setTimeout(()=>{
		// 	this.setState({proactive:true,proactiveMsg:"This is the default message for our demo "});
		// },5000)
	}

	componentWillUnmount() {
		window.removeEventListener('message',this.messageHandler,false);
	}

	async loadCss () {
		var {theme} = this.props;
		try{
			var [code,res] = await getCss(theme);
			this.setState({styleCss:res});
		} catch(e){
			console.log('error fetching css',e,e.stack);
		}
	}

	closeChat () {
		var {OS} = Detect;		
		console.log("ismobile",OS);		
		if (OS=="Android" || OS=="iOS" ){		
		    //console.log("ismobile",OS);		
		    this.hideChat();		
		    exit;		
		}
		this.setState({opened: false,progress:true},()=>{
			setTimeout(()=>{
				this.setState({hidden:true,progress:false});
			},transitionTime+100);
		});
		this.postMes("close");
	};

	openChat (proactive) {
		this.setState({hidden:false,progress:true,proactiveMsg:null},()=>{
			setTimeout(()=>{
				this.setState({opened:true,progress:false});	
			},100);
			this.postMes("chat");
			
		});
	};

	hideChat () {
		
		this.setState({hideBot:true,hidden:true,progress:true,proactiveMsg:null},()=>{
			setTimeout(()=>{
				this.setState({opened:true,progress:false});	
			},transitionTime+100);
			//this.postMes("chat");
		});
		
	}

	deauthenticate () {}

	postMes (msg){
		//console.log('msg',msg,'guid',this.guid);
		if(!this.iframe){
			return;
		}
		var win = this.iframe.contentWindow;
		win.postMessage(msg,"*");
	};

	authenticateFunc (authArray){
		console.log("after 2000",authArray);
		this.postMes(authArray);
	}

	

	messageHandler (e) {
		//console.log('mess handler',e.data,e);
		//console.log("e.data", e.data['key']);
		if(e.data==='closeChat'){
			this.closeChat();
		}else if(e.data==='iframeMounted'){
			console.log("iframeMounted",this.state.authKey);
			if (this.state.authKey){
				this.postMes(this.state.authKey);
				console.log("postMes authKey",this.state.authKey);
				this.setState({"authKey":false});
			}else if (this.state.setDeauthenticate){
				console.log("postMes setDeauthenticate",this.state.setDeauthenticate);
				this.postMes("deauthenticate", "*");
				this.setState({"deauthenticate":false});
			}
		} else if(e.data==='openChat'){
			this.openChat();
		}else if (e.data['key']==='authenticate'){
			var authData = e.data;
			if (this.state.iframeMounted){
				this.postMes(authData);
			}else{
				this.setState({"authKey": authData});
				setTimeout(this.authenticateFunc,2000,authData);
				console.log("setAUTHKEY",this.state.authKey);
			}
			
		}else if (e.data==="hideChat"){
			this.hideChat(e.data);

		}else if(e.data === "deauthenticate"){
			this.postMes(e.data);
			this.setState({"setDeauthenticate":true});
		} else{
			
				if(e.data && (typeof e.data === 'object')){
					if(e.data.type==='proactive'){
						var {opened,progress} = this.state;
						if(!(opened || progress)){
							this.setState({proactive:true,proactiveMsg:e.data.msg});
						}
					}
					// if(e.data.type=='cart'){
					// 	console.log('cart mess ',e.data)
					// } 

				} else {
					console.warn(`unknown message ${e.data} `,e);
				}
			
		}
	};
	
	toggleChat () {
		var {opened,progress} = this.state;
		console.log('toggling','opened',opened,'progr',progress);
		if(!progress){
			if(opened){
				console.log("toggling", "closeChat");
				this.closeChat();
			} else {
				console.log("toggling", "openChat");
				this.openChat();
			}
		} else {
			console.log('progress in progress');
		}
	};


	render() {
		var {children,...props} = this.props;
		var urlHash = JSON.stringify(props);
		console.log("urlHash",urlHash);
		var {opened,hidden, styleCss,proactiveMsg,hideBot } = this.state;
		if(!styleCss){
			return null;
		}
		var status = JSON.stringify(this.state,null,2);


		var hiddenCl = (hidden)? process.env.hidden: "";
		var activeCl = (opened)? process.env.active: "";
		var hideBotCl = (hideBot)? process.env.hideBot:"";


		return (

			<div className={`${process.env.outerWrapper} ${activeCl} ${hideBotCl}`}>
				{/* <pre>
									{JSON.stringify(this.state,null,2)}
								</pre> 
				*/}

				<style>
					{styleCss}
				</style>
				<div className={`${process.env.contentOuter} ${hiddenCl}`}>
					
					<div className={`${process.env.mainDiv} `}>
						<div className={process.env.header}>
							<div className="botimage">
							<span></span></div>
							<div className={process.env.headerIcons}>
								{/*<div title="Mail transcript" className={`cov ${process.env.envelope}`} 
									dangerouslySetInnerHTML={{__html:envelopeSvg}} 
									onClick={()=>{this.postMes("mailtranscipt")}} >	
									
								</div>

								<div title="Talk to human" className={`cov ${process.env.agenticon}`} 
									dangerouslySetInnerHTML={{__html:agentSvg}}
									onClick={()=>{this.postMes("transfer_to_agent")}}>	
									
								</div>*/}


								{/*<div title="Like" className={`cov ${process.env.thumbsup}`} 
									 dangerouslySetInnerHTML={{__html:upSvg}}
									onClick={()=>{this.postMes("thumbsup")}}
									 >
									
								</div>
								<div title="DisLike" className={`cov ${process.env.thumbsdown}`} 
									dangerouslySetInnerHTML={{__html:upSvg}}
									onClick={()=>{this.postMes("thumbsdown")}}
									>	
									
								</div>*/}

								<div title="Minimize" className="cov iconminimize"
									dangerouslySetInnerHTML={{__html:minusSVG}}
									onClick={()=>{this.closeChat()}}
									>	
									
								</div>
							</div>
						</div>
						{/*<div className={process.env['sub-header']}>
							
						</div>*/}
						<div className={process.env.content}>
							<iframe ref={(w)=>{this.iframe = w;}} src={`${process.env.IFRAME_URL}#${urlHash}`} frameborder="0" className={process.env['content-iframe']}></iframe>
						</div>
					</div>
				</div>
				<Bubble msg={proactiveMsg} handler={this.openChat} />
				<div className={process.env.anchor} onClick={this.toggleChat}>
					<div className={process.env["anchor-image"]}></div>
					<div className={process.env["anchor-text"]}></div>
				</div>
			</div>
			);

	}
};


// WEBPACK FOOTER //
// ./App.jsx